<template><div class="hidden"></div></template>

<script>
import { defineComponent } from 'vue'
import lodash from 'lodash'
const { debounce } = lodash

export default defineComponent({
  name: 'DataGetter',
  components: {},
  props: {
    eventToListen: {
      type: String,
      default: 'app_data_updated',
    },
    contentId: {
      type: String,
      default: '',
    },
    debounceDelay: {
      type: Number,
      default: 10,
    },
    searchQuery: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      data: {},
      eventsIds: [],
    }
  },
  mounted() {
    this.initDebunceGetting()
    this.debunceGetData()
    const id = this.$Events.handleEvent(this.eventToListen, this.debunceGetData)
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
    this.unsubscribeToResponse()
  },
  methods: {
    initDebunceGetting() {
      const vue = this
      this.debunceGetData = debounce(function () {
        vue.getData()
      }, this.debounceDelay)
    },
    debunceGetData() {},
    refresh() {
      this.debunceGetData()
    },
    async getData() {
      if (this.$Commons.isEmpty(this.contentId)) return
      this.unsubscribeToResponse()
      const { unsubscribe } = this.$Events.sendDataRequest(
        this.contentId,
        this.onResponse,
        this.searchQuery,
      )
      this.unsubscribeToResponse = unsubscribe
    },
    unsubscribeToResponse() {},
    onResponse(data) {
      if (!data) {
        this.$emit('dataIsEmpty', data)
        return
      }
      this.data = data
      this.$emit('dataAvailable', data)
    },
    isVisible() {
      return !this.isHidden
    },
  },
  watch: {
    eventToListen(newVal) {
      console.log('props updated', newVal)
      this.unsubscribeToResponse()
      this.debunceGetData()
    },
    contentId(newVal) {
      console.log('props updated', newVal)
      this.unsubscribeToResponse()
      this.debunceGetData()
    },
    searchQuery: {
      deep: true,
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return
        console.log('props updated', newVal)
        this.unsubscribeToResponse()
        this.debunceGetData()
      },
    },
  },
})
</script>
